export default "__VITE_ASSET__aosGJ84K__"